import React, { useState } from 'react';
import emailjs from '@emailjs/browser';

const EMAILJS_SERVICE_ID = 'service_ogpr38r';
const EMAILJS_TEMPLATE_ID = 'template_dq91kmj';
const EMAILJS_PUBLIC_KEY = 'vqz4OSZR12Rqdt0cU';

export default function Iletisim() {
  const [contactForm, setContactForm] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
  });

  const [contactErrors, setContactErrors] = useState({});
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);

  const handleContactChange = (e) => {
    const { name, value } = e.target;
    setContactForm((prev) => ({ ...prev, [name]: value }));
  };

  const validateContactForm = () => {
    const errors = {};
    if (!contactForm.name) errors.name = 'Ad gereklidir';
    if (!contactForm.email) errors.email = 'E-posta gereklidir';
    if (!contactForm.subject) errors.subject = 'Konu gereklidir';
    if (!contactForm.message) errors.message = 'Mesaj gereklidir';
    setContactErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateContactForm()) return;

    setSending(true);
    try {
      await emailjs.send(
        EMAILJS_SERVICE_ID,
        EMAILJS_TEMPLATE_ID,
        {
          from_name: contactForm.name,
          from_email: contactForm.email,
          subject: contactForm.subject,
          message: contactForm.message,
        },
        EMAILJS_PUBLIC_KEY
      );
      setSent(true);
      setContactForm({ name: '', email: '', subject: '', message: '' });
    } catch {
      alert('Mesaj gönderilemedi. Lütfen tekrar deneyin.');
    } finally {
      setSending(false);
    }
  };

  return (
    <section className="py-5 iletisim-page">
      <div className="container">
        <h1 className="text-center mb-5" style={{marginTop: '50px'}}>İletişim</h1>
        <div className="row">
          <div className="col-lg-6 mb-4">
            <div className="card p-4 h-100">
              <h3 className="mb-4">Bize Ulaşın</h3>
              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <label htmlFor="name" className="form-label">
                    Ad <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    className={`form-control ${contactErrors.name ? 'is-invalid' : ''}`}
                    value={contactForm.name}
                    onChange={handleContactChange}
                    placeholder="Adınız"
                  />
                  {contactErrors.name && <div className="invalid-feedback d-block">{contactErrors.name}</div>}
                </div>

                <div className="mb-3">
                  <label htmlFor="contact-email" className="form-label">
                    E-posta <span className="text-danger">*</span>
                  </label>
                  <input
                    type="email"
                    id="contact-email"
                    name="email"
                    className={`form-control ${contactErrors.email ? 'is-invalid' : ''}`}
                    value={contactForm.email}
                    onChange={handleContactChange}
                    placeholder="example@email.com"
                  />
                  {contactErrors.email && <div className="invalid-feedback d-block">{contactErrors.email}</div>}
                </div>

                <div className="mb-3">
                  <label htmlFor="subject" className="form-label">
                    Konu <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    id="subject"
                    name="subject"
                    className={`form-control ${contactErrors.subject ? 'is-invalid' : ''}`}
                    value={contactForm.subject}
                    onChange={handleContactChange}
                    placeholder="Konu"
                  />
                  {contactErrors.subject && <div className="invalid-feedback d-block">{contactErrors.subject}</div>}
                </div>

                <div className="mb-3">
                  <label htmlFor="message" className="form-label">
                    Mesaj <span className="text-danger">*</span>
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    className={`form-control ${contactErrors.message ? 'is-invalid' : ''}`}
                    rows="5"
                    value={contactForm.message}
                    onChange={handleContactChange}
                    placeholder="Mesajınız"
                  ></textarea>
                  {contactErrors.message && <div className="invalid-feedback d-block">{contactErrors.message}</div>}
                </div>

                {sent && (
                  <div className="alert alert-success mb-3">
                    Mesajınız başarıyla gönderildi. Teşekkürler!
                  </div>
                )}
                <button
                  type="submit"
                  className="btn w-100 py-3 mt-2 d-flex align-items-center justify-content-center gap-2"
                  style={{ 
                    backgroundColor: '#220d1c', 
                    border: '1px solid rgba(255, 255, 255, 0.2)', 
                    color: '#fff',
                    borderRadius: '12px',
                    fontWeight: '600',
                    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                    boxShadow: '0 4px 15px rgba(34, 13, 28, 0.2)',
                    position: 'relative',
                    overflow: 'hidden'
                  }}
                  disabled={sending}
                  onMouseOver={(e) => {
                    e.currentTarget.style.backgroundColor = '#3d1732';
                    e.currentTarget.style.transform = 'translateY(-2px)';
                    e.currentTarget.style.boxShadow = '0 6px 20px rgba(34, 13, 28, 0.3)';
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.backgroundColor = '#220d1c';
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = '0 4px 15px rgba(34, 13, 28, 0.2)';
                  }}
                >
                  {sending ? (
                    <>
                      <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                      <span>İletiliyor...</span>
                    </>
                  ) : (
                    <>
                      <span>Mesajı Gönder</span>
                      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <line x1="22" y1="2" x2="11" y2="13"></line>
                        <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
                      </svg>
                    </>
                  )}
                </button>
              </form>
            </div>
          </div>

          <div className="col-lg-6 mb-4">
            <div className="card p-4">
              <h3 className="mb-4">İletişim Bilgileri</h3>
              <div className="mb-4">
                <h5 className="mb-2">📧 E-posta</h5>
                <p>
                  <a href="mailto:anktandoganrac@gmail.com">anktandoganrac@gmail.com</a>
                </p>
              </div>

              <div className="mb-4">
                <h5 className="mb-2">Yusuf Ufuk Altınöz</h5>
                <p className="mb-1">Bir Zamanlar Konferans Ana Komite Başkanı</p>
                <p className="mb-0">
                  Telefon Numarası: <a href="tel:+905310345705">+90 531 034 57 05</a>
                </p>
              </div>

              <div className="mb-4">
                <h5 className="mb-2">Pınar Tektaş</h5>
                <p className="mb-1">Ankara Tandoğan Rotaract Kulübü Başkanı</p>
                <p className="mb-0">
                  Telefon Numarası: <a href="tel:+905517059113">+90 551 705 91 13</a>
                </p>
              </div>

              <div className="mt-5" style={{ height: '400px' }}>
                <iframe
                  title="AQI Pegasos Resort Location"
                  width="100%"
                  height="100%"
                  frameBorder="0"
                  style={{ border: 0 }}
                  src="https://www.google.com/maps/embed/v1/place?key=AIzaSyBPphyMe91Twgiuf3654gUMOlu6JSTlzsA&q=AQI+Pegasos+Resort+Hotel+36.637171415053784%2C31.75168019685816"
                  allowFullScreen
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
